import React from 'react'
import portfolio from "./img/portfolio.jpg"
import Netflic from "./img/netflix.jpg"
import Qr from "./img/Qr.jpg"


const Portfolio = () => {
  return (
   <section className="portfolio" id='portfolio' style={{"marginTop":"30px"}}>
<h1 className="text-center page-header" style={{"font-weight": "700"}}>Portfolio</h1>
    <h4 className="text-center" style={{"font-family": 'Crete Round'}}>My recent work
</h4>
    <div className='container'>
        <div className="row">
        <div className="col col-md-3"></div>
            <div className="col col-md-6">
            <div id="carouselExampleCaptions" className="carousel slide">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={portfolio} className="d-block w-100" alt="Portfolio Website"/>
      <div className="carousel-caption d-none d-md-block">
        <h5>Portfolio Website</h5>
        <p>Personal portfolio built with React.js showcasing skills and projects</p>
      </div>
    </div>
    <div className="carousel-item">
      <img src={Netflic} className="d-block w-100" alt="Netflix Clone"/>
      <div className="carousel-caption d-none d-md-block">
        <h5>Netflix Clone</h5>
        <p>Movie streaming platform clone using React and TMDB API</p>
      </div>
    </div>
    <div className="carousel-item">
      <img src={Qr} className="d-block w-100" alt="QR Code Generator"/>
      <div className="carousel-caption d-none d-md-block">
        <h5>QR Code Generator</h5>
        <p>Web application to generate QR codes for URLs and text</p>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
            </div>
            <div className="col col-md-3"></div>
        </div>
    </div>
   </section>
  )
}

export default Portfolio